export default {
    name : "Tools",
    data()
    {
        return {
            time : null
        };
    },
    methods : {
        debounce( func, timeout, noTimeCheck = false )
        {
            if(!noTimeCheck)
            {
                if(!this.time)
                {
                    func();
                    this.time = 1;
                    return;
                }
            }
            clearTimeout(this.time);
            this.time = setTimeout(func, timeout ? timeout : 500);
        }
    }
};